// src/pages/VerificationSuccess.js

import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { StyledButton } from '../components/StyledComponents';

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(6),
    textAlign: 'center',
    borderRadius: theme.spacing(2),
    boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .1)',
    maxWidth: 500,
    width: '100%',
}));

const SuccessIcon = styled(CheckCircleIcon)(({ theme }) => ({
    fontSize: 80,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(3),
}));

function VerificationSuccess() {
    const handleOpenApp = () => {
        // Placeholder for deep linking logic
        window.location.href = 'borrowed://open';

        // Fallback for web after short delay
        setTimeout(() => {
            window.location.href = '/';
        }, 500);
    };

    return (
        <StyledContainer maxWidth="sm">
            <StyledPaper elevation={3}>
                <SuccessIcon />
                <Typography variant="h4" component="h1" gutterBottom>
                    Email Verified Successfully!
                </Typography>
                <Typography variant="body1" paragraph color="textSecondary">
                    Thank you for verifying your email address. Your account is now activated, and you can start using Borrowed.
                </Typography>
                <Box mt={4}>
                    <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={handleOpenApp}
                        size="large"
                        fullWidth
                    >
                        Open Borrowed
                    </StyledButton>
                </Box>
            </StyledPaper>
        </StyledContainer>
    );
}

export default VerificationSuccess;